import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FabricanteInserirComponent } from './fabricante-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: FabricanteInserirComponent }
    ])],
    exports: [RouterModule]
})
export class FabricanteInserirRoutingModule { }
